"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./NewsTable.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const renderRelatedScrips = relatedScrips => {
  if (relatedScrips.length) {
    const additionalScrips = relatedScrips.length > 2 ? relatedScrips.length - 2 : 0;
    const scripsForRender = relatedScrips.slice(0, 2);
    return (0, _pragma.createFelaElement)(_.View, {
      flexDirection: "row",
      gap: "xsmall",
      inline: true
    }, scripsForRender.map(({
      name,
      exchange
    }) => (0, _pragma.createFelaElement)(_.View, {
      alignItems: "center",
      key: name,
      gap: "xxsmall"
    }, (0, _pragma.createFelaElement)(_.Text, {
      variant: "meta",
      color: "text.1",
      transform: "uppercase"
    }, name), (0, _pragma.createFelaElement)(_.Tag, {
      variant: "greyInverse"
    }, exchange))), additionalScrips ? (0, _pragma.createFelaElement)(_.Tag, {
      variant: "greyInverse"
    }, "+".concat(additionalScrips)) : null);
  }

  return '';
};
/**
 * The NewsTable component is used to show news in table format
 */


const NewsTable = /*#__PURE__*/React.forwardRef(({
  news,
  collapsed = false,
  ...otherProps
}, ref) => {
  if (collapsed) {
    return (0, _pragma.createFelaElement)(_.View, _extends({
      flex: true,
      flexDirection: "column"
    }, otherProps, {
      ref: ref
    }), news.map(({
      onClick,
      attribution,
      time,
      headline,
      relatedScrips = []
    }, index) => (0, _pragma.createFelaElement)(_.View, {
      onClick: onClick,
      key: index // eslint-disable-line react/no-array-index-key
      ,
      flex: true,
      flexDirection: "column",
      css: css.newsBlock,
      padding: ['xlarge', 'medium'],
      gap: "medium"
    }, (0, _pragma.createFelaElement)(_.View, {
      flexDirection: "column",
      gap: "xsmall"
    }, (0, _pragma.createFelaElement)(_.Text, {
      variant: "body",
      color: "text.1"
    }, headline), (0, _pragma.createFelaElement)(_.Text, {
      variant: "meta",
      color: "text.2"
    }, "".concat(attribution, " \u2022 ").concat(time))), renderRelatedScrips(relatedScrips))));
  }

  return (0, _pragma.createFelaElement)(_.Table, otherProps, (0, _pragma.createFelaElement)(_.TableBody, null, news.map(({
    onClick,
    attribution,
    time,
    headline,
    relatedScrips = []
  }, index) => (0, _pragma.createFelaElement)(_.TableRow, {
    onClick: onClick // eslint-disable-next-line react/no-array-index-key
    ,
    key: index,
    interactive: true,
    dividerPartial: true
  }, (0, _pragma.createFelaElement)(_.TableCell, {
    css: css.emptyCell,
    padding: "none"
  }), (0, _pragma.createFelaElement)(_.TableCell, {
    css: css.timeCell,
    padding: ['medium', 'xsmall']
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2",
    children: time
  })), (0, _pragma.createFelaElement)(_.TableCell, {
    css: css.attributionCell,
    padding: ['medium', 'xsmall']
  }, (0, _pragma.createFelaElement)(_.Text, {
    children: attribution,
    color: "text.2",
    variant: "meta"
  })), (0, _pragma.createFelaElement)(_.TableCell, {
    padding: ['medium', 'xsmall']
  }, (0, _pragma.createFelaElement)(_.Text, {
    children: headline,
    color: "text.1",
    variant: "body"
  })), (0, _pragma.createFelaElement)(_.TableCell, {
    align: "right",
    padding: ['medium', 'xsmall']
  }, renderRelatedScrips(relatedScrips)), (0, _pragma.createFelaElement)(_.TableCell, {
    css: css.emptyCell,
    padding: "none"
  })))));
});
NewsTable.displayName = 'NewsTable';
var _default = NewsTable;
exports.default = _default;
//# sourceMappingURL=NewsTable.js.map